import axios from 'axios'
import API from './index'

export default {

  get(id) {
    const url = API.BASE_URL + 'Money/' + id
    return axios
      .get(url, {
      })
      .then(response => {
        return response.data
      })
  },

  getWinnings(year){
    const url = API.BASE_URL + 'Money/getWinnings/' + year
    return axios
      .get(url, {
      })
      .then(response => {
        return response.data
      })
    
  },

  getMemberWinnings(year, memberId) {
    const url = API.BASE_URL + 'Money/getMemberWinning/' + year + '/' + memberId
    return axios
      .get(url, {
      })
      .then(response => {
        return response.data
      })
  }
}
